import { render, staticRenderFns } from "./ProductSale.vue?vue&type=template&id=424285f8&scoped=true&"
import script from "./ProductSale.vue?vue&type=script&lang=js&"
export * from "./ProductSale.vue?vue&type=script&lang=js&"
import style0 from "./ProductSale.vue?vue&type=style&index=0&id=424285f8&prod&scoped=true&lang=css&"
import style1 from "./ProductSale.vue?vue&type=style&index=1&id=424285f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424285f8",
  null
  
)

export default component.exports